import { BRAND_CONFIG } from '@@brand/config'
import { ComponentPropsWithoutRef } from 'react'


type ProductPlaceholderProps = ComponentPropsWithoutRef<'img'> & {
  /**
   * Product image URL. If not provided or fails to load, shows placeholder
   */
  src?: string;
}

/**
 * Product image component with fallback to brand-specific placeholder
 * The placeholder can be overridden at CI level via VITE_BRAND_PRODUCT_PLACEHOLDER
 */
export default function ProductPlaceholder ({ 
  src, 
  alt = '',
  onError,
  ...props 
}: ProductPlaceholderProps) {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.currentTarget
    const placeholderUrl = BRAND_CONFIG.images.productPlaceholder
    
    // Prevent infinite error loop if placeholder also fails
    if (target.src !== window.location.origin + placeholderUrl) {
      target.src = placeholderUrl
    }
    
    // Call original onError handler if provided
    onError?.(e)
  }

  return (
    <img
      src={src || BRAND_CONFIG.images.productPlaceholder}
      alt={alt}
      onError={handleError}
      {...props}
    />
  )
}